import React, { useRef, useState, useMemo } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Container } from "react-bootstrap";
import { LuMoveLeft, LuMoveRight } from "../../../../assets/logos/index";
import LightBox from "../../LightBox";

import {
  news1,
  news2,
  news3,
  news4,
  news5,
  news6,
  news7,
  news8,
  news9,
  news10,
  news11,
  news12,
  news13,
} from "../../../../assets/images/index";

const NewsArticles = () => {
  const swiperRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);

  const shuffledArticles = useMemo(() => {
    const articles = [
      news1,
      news2,
      news3,
      news4,
      news5,
      news6,
      news7,
      news8,
      news9,
      news10,
      news11,
      news12,
      news13,
    ];

    for (let i = articles.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [articles[i], articles[j]] = [articles[j], articles[i]];
    }

    return articles;
  }, []);

  const handlePrevClick = () => {
    swiperRef.current.swiper.slidePrev();
  };

  const handleNextClick = () => {
    swiperRef.current.swiper.slideNext();
  };

  return (
    <div>
      <Container className="py-lg-4 py-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h2 className="top-programmes-title photo-gallery-title align-items-center heading-font">
            News Articles
          </h2>
          <span>
            <button
              className="btn px-3 py-0 fs-2 border-0"
              onClick={handlePrevClick}
              aria-label="handlePrevClick"
            >
              <LuMoveLeft />
            </button>
            <button
              className="btn px-3 py-0 fs-2 border-0"
              onClick={handleNextClick}
              aria-label="handleNextClick"
            >
              <LuMoveRight />
            </button>
          </span>
        </div>

        <Swiper
          ref={swiperRef}
          spaceBetween={10}
          modules={[]}
          className="mySwiper"
          breakpoints={{
            400: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 4 },
          }}
        >
          {shuffledArticles?.map((image, index) => (
            <SwiperSlide key={index} className="photo-gallery-slider-card">
              <img
                loading="lazy"
                onClick={() => {
                  setPhotoIndex(index);
                  setOpen(true);
                }}
                src={image}
                alt={`news_article_img_${index}`}
                className="news_article_img w-100"
                style={{ height: "250px", objectFit: "cover" }}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </Container>

      <LightBox
        open={open}
        onClose={() => setOpen(false)}
        photoIndex={photoIndex}
        images={shuffledArticles}
      />
    </div>
  );
};

export default NewsArticles;
